module.exports = __webpack_public_path__ + "static/media/schoolpic03@2x.498857e4.png";